module.exports = __webpack_public_path__ + "static/media/listImoveisDesconto.297ffa85.png";